export const states = [
  {
    stateId: 1,
    name: 'Alabama',
    description: null,
    id: 6,
    symbol: 'AL',
    uri: 'alabama',
    'states_translations.id': 6,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 6,
  },
  {
    stateId: 2,
    name: 'California',
    description: null,
    id: 1,
    symbol: 'CA',
    uri: 'california',
    'states_translations.id': 1,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 1,
  },
  {
    stateId: 3,
    name: 'Arizona',
    description: null,
    id: 5,
    symbol: 'AZ',
    uri: 'arizona',
    'states_translations.id': 5,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 5,
  },
  {
    stateId: 4,
    name: 'Connecticut',
    description: null,
    id: 2,
    symbol: 'CT',
    uri: 'connecticut',
    'states_translations.id': 2,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 2,
  },
  {
    stateId: 5,
    name: 'Delaware',
    description: null,
    id: 4,
    symbol: 'DE',
    uri: 'delaware',
    'states_translations.id': 4,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 4,
  },
  {
    stateId: 6,
    name: 'Alaska',
    description: null,
    id: 3,
    symbol: 'AK',
    uri: 'alaska',
    'states_translations.id': 3,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 3,
  },
  {
    stateId: 7,
    name: 'Florida',
    description: null,
    id: 7,
    symbol: 'FL',
    uri: 'florida',
    'states_translations.id': 7,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 7,
  },
  {
    stateId: 8,
    name: 'Colorado',
    description: null,
    id: 9,
    symbol: 'CO',
    uri: 'colorado',
    'states_translations.id': 9,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 9,
  },
  {
    stateId: 9,
    name: 'Arkansas',
    description: null,
    id: 11,
    symbol: 'AR',
    uri: 'arkansas',
    'states_translations.id': 11,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 11,
  },
  {
    stateId: 10,
    name: 'District of Columbia',
    description: null,
    id: 8,
    symbol: 'DC',
    uri: 'district-of-columbia',
    'states_translations.id': 8,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 8,
  },
  {
    stateId: 11,
    name: 'Georgia',
    description: null,
    id: 10,
    symbol: 'GA',
    uri: 'georgia',
    'states_translations.id': 10,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 10,
  },
  {
    stateId: 12,
    name: 'Hawaii',
    description: null,
    id: 12,
    symbol: 'HI',
    uri: 'hawaii',
    'states_translations.id': 12,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 12,
  },
  {
    stateId: 13,
    name: 'Idaho',
    description: null,
    id: 13,
    symbol: 'ID',
    uri: 'idaho',
    'states_translations.id': 13,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 13,
  },
  {
    stateId: 14,
    name: 'Illinois',
    description: null,
    id: 14,
    symbol: 'IL',
    uri: 'illinois',
    'states_translations.id': 14,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 14,
  },
  {
    stateId: 15,
    name: 'Indiana',
    description: null,
    id: 15,
    symbol: 'IN',
    uri: 'indiana',
    'states_translations.id': 15,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 15,
  },
  {
    stateId: 16,
    name: 'Iowa',
    description: null,
    id: 16,
    symbol: 'IA',
    uri: 'iowa',
    'states_translations.id': 16,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 16,
  },
  {
    stateId: 17,
    name: 'Kansas',
    description: null,
    id: 17,
    symbol: 'KS',
    uri: 'kansas',
    'states_translations.id': 17,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 17,
  },
  {
    stateId: 18,
    name: 'Kentucky',
    description: null,
    id: 18,
    symbol: 'KY',
    uri: 'kentucky',
    'states_translations.id': 18,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 18,
  },
  {
    stateId: 19,
    name: 'Louisiana',
    description: null,
    id: 19,
    symbol: 'LA',
    uri: 'louisiana',
    'states_translations.id': 19,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 19,
  },
  {
    stateId: 20,
    name: 'Maine',
    description: null,
    id: 20,
    symbol: 'ME',
    uri: 'maine',
    'states_translations.id': 20,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 20,
  },
  {
    stateId: 21,
    name: 'Maryland',
    description: null,
    id: 21,
    symbol: 'MD',
    uri: 'maryland',
    'states_translations.id': 21,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 21,
  },
  {
    stateId: 22,
    name: 'Massachusetts',
    description: null,
    id: 22,
    symbol: 'MA',
    uri: 'massachusetts',
    'states_translations.id': 22,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 22,
  },
  {
    stateId: 23,
    name: 'Michigan',
    description: null,
    id: 23,
    symbol: 'MI',
    uri: 'michigan',
    'states_translations.id': 23,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 23,
  },
  {
    stateId: 24,
    name: 'Minnesota',
    description: null,
    id: 24,
    symbol: 'MN',
    uri: 'minnesota',
    'states_translations.id': 24,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 24,
  },
  {
    stateId: 25,
    name: 'Mississippi',
    description: null,
    id: 26,
    symbol: 'MS',
    uri: 'mississippi',
    'states_translations.id': 26,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 26,
  },
  {
    stateId: 26,
    name: 'Missouri',
    description: null,
    id: 25,
    symbol: 'MO',
    uri: 'missouri',
    'states_translations.id': 25,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 25,
  },
  {
    stateId: 27,
    name: 'Montana',
    description: null,
    id: 27,
    symbol: 'MT',
    uri: 'montana',
    'states_translations.id': 27,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 27,
  },
  {
    stateId: 28,
    name: 'Nebraska',
    description: null,
    id: 28,
    symbol: 'NE',
    uri: 'nebraska',
    'states_translations.id': 28,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 28,
  },
  {
    stateId: 29,
    name: 'Nevada',
    description: null,
    id: 29,
    symbol: 'NV',
    uri: 'nevada',
    'states_translations.id': 29,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 29,
  },
  {
    stateId: 30,
    name: 'New Hampshire',
    description: null,
    id: 30,
    symbol: 'NH',
    uri: 'new-hampshire',
    'states_translations.id': 30,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 30,
  },
  {
    stateId: 31,
    name: 'New Jersey',
    description: null,
    id: 31,
    symbol: 'NJ',
    uri: 'new-jersey',
    'states_translations.id': 31,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 31,
  },
  {
    stateId: 32,
    name: 'New Mexico',
    description: null,
    id: 32,
    symbol: 'NM',
    uri: 'new-mexico',
    'states_translations.id': 32,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 32,
  },
  {
    stateId: 33,
    name: 'New York',
    description: null,
    id: 33,
    symbol: 'NY',
    uri: 'new-york',
    'states_translations.id': 33,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 33,
  },
  {
    stateId: 34,
    name: 'North Carolina',
    description: null,
    id: 34,
    symbol: 'NC',
    uri: 'north-carolina',
    'states_translations.id': 34,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 34,
  },
  {
    stateId: 35,
    name: 'North Dakota',
    description: null,
    id: 35,
    symbol: 'ND',
    uri: 'north-dakota',
    'states_translations.id': 35,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 35,
  },
  {
    stateId: 36,
    name: 'Ohio',
    description: null,
    id: 36,
    symbol: 'OH',
    uri: 'ohio',
    'states_translations.id': 36,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 36,
  },
  {
    stateId: 37,
    name: 'Oregon',
    description: null,
    id: 37,
    symbol: 'OR',
    uri: 'oregon',
    'states_translations.id': 37,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 37,
  },
  {
    stateId: 38,
    name: 'Pennsylvania',
    description: null,
    id: 38,
    symbol: 'PA',
    uri: 'pennsylvania',
    'states_translations.id': 38,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 38,
  },
  {
    stateId: 39,
    name: 'Rhode Island',
    description: null,
    id: 39,
    symbol: 'RI',
    uri: 'rhode-island',
    'states_translations.id': 39,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 39,
  },
  {
    stateId: 40,
    name: 'South Carolina',
    description: null,
    id: 40,
    symbol: 'SC',
    uri: 'south-carolina',
    'states_translations.id': 40,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 40,
  },
  {
    stateId: 41,
    name: 'South Dakota',
    description: null,
    id: 41,
    symbol: 'SD',
    uri: 'south-dakota',
    'states_translations.id': 41,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 41,
  },
  {
    stateId: 42,
    name: 'Tennessee',
    description: null,
    id: 42,
    symbol: 'TN',
    uri: 'tennessee',
    'states_translations.id': 42,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 42,
  },
  {
    stateId: 43,
    name: 'Utah',
    description: null,
    id: 43,
    symbol: 'UT',
    uri: 'utah',
    'states_translations.id': 43,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 43,
  },
  {
    stateId: 44,
    name: 'Virginia',
    description: null,
    id: 44,
    symbol: 'VA',
    uri: 'virginia',
    'states_translations.id': 44,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 44,
  },
  {
    stateId: 45,
    name: 'Vermont',
    description: null,
    id: 46,
    symbol: 'VT',
    uri: 'vermont',
    'states_translations.id': 46,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 46,
  },
  {
    stateId: 46,
    name: 'Texas',
    description: null,
    id: 45,
    symbol: 'TX',
    uri: 'texas',
    'states_translations.id': 45,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 45,
  },
  {
    stateId: 47,
    name: 'Washington',
    description: null,
    id: 47,
    symbol: 'WA',
    uri: 'washington',
    'states_translations.id': 47,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 47,
  },
  {
    stateId: 48,
    name: 'West Virginia',
    description: null,
    id: 48,
    symbol: 'WV',
    uri: 'west-virginia',
    'states_translations.id': 48,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 48,
  },
  {
    stateId: 49,
    name: 'Wisconsin',
    description: null,
    id: 49,
    symbol: 'WI',
    uri: 'wisconsin',
    'states_translations.id': 49,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 49,
  },
  {
    stateId: 50,
    name: 'Wyoming',
    description: null,
    id: 50,
    symbol: 'WY',
    uri: 'wyoming',
    'states_translations.id': 50,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 50,
  },
  {
    stateId: 51,
    name: 'AP',
    description: null,
    id: 51,
    symbol: 'AP',
    uri: 'ap',
    'states_translations.id': 51,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 51,
  },
  {
    stateId: 52,
    name: 'Marshall Islands',
    description: null,
    id: 52,
    symbol: 'MH',
    uri: 'marshall-islands',
    'states_translations.id': 52,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 52,
  },
  {
    stateId: 53,
    name: 'Northern Mariana Islands',
    description: null,
    id: 53,
    symbol: 'MP',
    uri: 'northern-mariana-islands',
    'states_translations.id': 53,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 53,
  },
  {
    stateId: 54,
    name: 'Guam',
    description: null,
    id: 54,
    symbol: 'GU',
    uri: 'guam',
    'states_translations.id': 54,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 54,
  },
  {
    stateId: 55,
    name: 'Virgin Islands',
    description: null,
    id: 55,
    symbol: 'VI',
    uri: 'virgin-islands',
    'states_translations.id': 55,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 55,
  },
  {
    stateId: 56,
    name: 'American Samoa',
    description: null,
    id: 56,
    symbol: 'AS',
    uri: 'american-samoa',
    'states_translations.id': 56,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 56,
  },
  {
    stateId: 57,
    name: 'Puerto Rico',
    description: null,
    id: 57,
    symbol: 'PR',
    uri: 'puerto-rico',
    'states_translations.id': 57,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 57,
  },
  {
    stateId: 58,
    name: 'Palau',
    description: null,
    id: 58,
    symbol: 'PW',
    uri: 'palau',
    'states_translations.id': 58,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 58,
  },
  {
    stateId: 59,
    name: 'Federated States of Micronesia',
    description: null,
    id: 59,
    symbol: 'FM',
    uri: 'federated-states-of-micronesia',
    'states_translations.id': 59,
    'country.id': 1,
    'country.countries_translations.id': 1,
    'country.countries_translations.name': 'USA',
    countryName: 'USA',
    countryId: 1,
    translationId: 59,
  },
];
